import gql from 'graphql-tag';

export const GET_HSA_DETAILS = gql`
  query GetHSADetails($subscriberId: ID!, $hasFacets: Boolean!) {
    hsaDetails(subscriberId: $subscriberId) @include(if: $hasFacets) {
      availableBalance
      investmentAmount
      contributionAmount
      distributionAmount
    }
  }
`;
